import React from "react";
import { cn } from "@/utils/utils";

interface Props {
  className?: string;
}

const GradientBlur: React.FC<Props> = ({ className }) => (
  <div
    className={cn("absolute top-[28rem] left-[30rem] opacity-30", className)}
    style={{
      transform: "translate(-50%, -50%)",
      width: "100px",
      height: "100px",
      boxShadow:
        "0 0 40px 20px var(--glow-gradient-blur-inner), 0 0 100px 60px var(--glow-gradient-blur-mid), 0 0 200px 100px var(--glow-gradient-blur-outer)",
      borderRadius: "50%",
      filter: "blur(80px)"
    }}
  />
);

export default GradientBlur;
